import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aarambh-induction',
  templateUrl: './aarambh-induction.component.html',
  styleUrls: ['./aarambh-induction.component.scss']
})
export class AarambhInductionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
